import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import './stylus/main.styl'
import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
import store from '@/store/store'


Vue.config.productionTip = false

Vue.component('date-picker', VuePersianDatetimePicker)

Vue.use(Vuetify, {
  rtl: true,
  iconfont: 'mdi' // 'md' || 'mdi' || 'fa' || 'fa4'
})

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
